<script lang="ts">
	import { onMount } from 'svelte'

	import Footer from '$lib/components/Footer.svelte'
	import GoogleOneTap from '$lib/components/Google/OneTap.svelte'
	import Messages from '$lib/components/Messages.svelte'
	import environment from '$lib/environment'
	import { account } from '$lib/stores/account/account'
	import { OAuthProvider, signInWithProvider } from '$lib/stores/account/manager'
	import {
		InitAccSubPlanFeatures
	} from '$lib/stores/subscription_acc_plan_features/subscription_acc_plan_features'

	import MenuLeft from '../MenuLeft.svelte'
	import LayoutHeader from './LayoutHeader.svelte'

	//export let containerWidth = "1024" // full, 800
	export let containerWidth = '816' // full, 800

	let classWidth = containerWidth === 'full' ? 'dashboard' : 'limited'
	// let featureNotification_Viewed_enabled = false

	$: limitedMaxWidth = containerWidth + 'px'

	onMount(async () => {
		// Check if Plan of user has featured enabled
		await InitAccSubPlanFeatures()

	})

	interface CredentialResponse {
		credential: string;
		select_by: string;
	}

	const oneTapCallBack = async (response: CredentialResponse) => {
		// Send response to server
		console.log('========= googleOneTap response', response)
		signInWithProvider(OAuthProvider.Google)
	}

	let menuToggled = false
	function handleToggleMenu() {
		menuToggled = !menuToggled
	}
</script>

{#if !$account.registered}
	<GoogleOneTap clientId={environment.googleOneTapKey} callback={(r) => oneTapCallBack(r)} />
{/if}

<div class="content-container flex flex-col place-items-center">
	<div
		class="{classWidth} w-full place-items-center justify-items-center"
		style="--maxWidth: {limitedMaxWidth};"
	>
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<div class="menu-overlay" class:menu-toggled={menuToggled} on:click={handleToggleMenu} />
		<MenuLeft bind:menuToggled />

		<LayoutHeader on:toggle_menu={handleToggleMenu} />

		<Messages />
		<slot />
	</div>
</div>
<Footer />

<style lang="postcss">
	.content-container {
		transition: ease-in-out margin 0.15s;
	}
	.limited {
		max-width: var(--maxWidth);
	}
	.dashboard {
		max-width: 100%;
	}

	@media (min-width: 768px) {
		.content-container {
			margin-left: 12rem;
		}
	}

	@media (min-width: 1024px) {
		.content-container {
			margin-left: 14rem;
		}
	}

	@media (width >= 768px) {
		.menu-overlay {
			display: none;
		}
	}

	.menu-overlay {
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.7);
		z-index: 5;
		transform: translateX(-100%);
		transition: ease-in-out transform 0.15s;
	}

	.menu-overlay.menu-toggled {
		transform: translateX(0);
	}
</style>
